import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import clsx from 'clsx';
import { useA11yIdRegister } from '../hooks/use-a11y-connections.js';
import { badgeReset } from './badge-reset.css.js';

/**
 * BadgePrimitive is an unstyled (“headless”) component that handles badge functionality and a11y concerns.
 * Use a BadgePrimitive if you need a component that behaves like a badge but doesn't match UI3 styling.
 *
 * @see https://fpl.figma.design/primitives/badge/
 */
const BadgePrimitive = forwardRef(({ className, id: idIn, ...props }, ref) => {
    const { id, isRegistered } = useA11yIdRegister('description', { providedId: idIn });
    return (jsx("strong", { "data-fpl-component": "primitive", role: isRegistered ? 'note' : undefined, ...props, ref: ref, className: clsx(badgeReset, className), id: id }));
});
BadgePrimitive.displayName = 'BadgePrimitive';

export { BadgePrimitive };
//# sourceMappingURL=badge-primitive.js.map
